import { ItemCategoryStatus } from './item-category-status';

/*
 "ItemStatus":{
  "required":[
    "scannedCount",
    "totalCount",
    "categories"
  ],
    "type":"object",
    "properties":{
    "scannedCount":{
      "format":"int32",
        "description":"Anzahl bereits gescannter Gegenstände",
        "type":"integer"
    },
    "totalCount":{
      "format":"int32",
        "description":"Gesamtanzahl aller zu scannenden Gegenstände",
        "type":"integer"
    },
    "categories":{
      "description":"Scanstatus pro Gegenstandskategorie",
        "uniqueItems":false,
        "type":"array",
        "items":{
        "$ref":"#/definitions/ItemCategoryStatus"
      }
    }
  }
}
*/
export class ItemStatus {
  constructor(
    public scanned: number,
    public total: number,
    public categories: ItemCategoryStatus[]
  ) { }

  public static fromJSON(json: {
    scannedCount: number,
    totalCount: number,
    categories: any
  }): ItemStatus {
    if (!json) {
      throw new Error('ItemStatus JSON should not be undefined');
    }
    if (json.scannedCount === undefined || json.scannedCount === null) {
      throw new Error('ItemStatus JSON should have property: scannedCount');
    }
    if (json.totalCount === undefined || json.totalCount === null) {
      throw new Error('ItemStatus JSON should have property: totalCount');
    }

    if (!Array.isArray(json.categories)) {
      throw new Error('ItemStatus JSON should have property: categories');
    }

    const cats = json.categories.map(c => ItemCategoryStatus.fromJSON(c));
    return new ItemStatus(
      json.scannedCount,
      json.totalCount,
      cats
    );
  }

  public static get empty(): ItemStatus {
    return new ItemStatus(0, 0, []);
  }

  public get isEmpty(): boolean {
    return this.scanned === 0 && this.total === 0;
  }

  public get isComplete(): boolean {
    return this.scanned === this.total && this.total >= 0;
  }
}
